import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import _ from "lodash";
import PropTypes from "prop-types";

const StackedBarChart = (props) => {
  const {
  aixsConfig,
  barWidth,
  color,
  data,
  events,
  height,
  spaceLeft,
  toolTipData,
  tooltipConfig,
  width,
  yAxisData,
  yAxisDataArray,
  yAxisFormatter,
  yAxisMargin,
  yAxisRich,
  yAxisTextColor,
  xAxisMax="100",
  otherYAxisProperty,
  otherXAxisProperty,
  axisShowLabel,
  selectedMode,
  labelConfig,
  isFullStack,
  spaceRight,
  spaceBottom,
  spacetop,
  isScroll,
  scrollDirection,
  isScrollStartLimit,
  isScrollEndLimit,
  scrollBarBottomAlign,
} = props;
   const [legendSelected, setLegendSelected] = useState({});
 
  const getStackOption = () => {
    const categoryTotals = data[0].data.map((_, i) =>
      data.reduce((total, series) => {
        if (legendSelected[series.name] === false) {
          return total; 
        }
        return total + series.data[i];
      }, 0)
    );
  
    let option = {
      tooltip: tooltipConfig ?{ ...tooltipConfig } :{
        show: true,
        trigger: 'item',
        formatter: (toolTipData) => {
          if (toolTipData.seriesType === "bar") {
            const seriesData = data.find((series) => series.name === toolTipData.seriesName);

            const toolTipDataItem = seriesData.toolTipData[toolTipData.dataIndex];
        
            return `
              <div>
                <div>${toolTipDataItem.severity} </div>
                <div>${toolTipData.seriesName}: ${toolTipDataItem.value}</div>
              </div>
            `;
          }
        },
        
      },
      legend: {
   
        orient: "horizontal",
        icon:"circle" ,
        left: 10,
        type: "scroll",
        selectedMode: !selectedMode ? selectedMode :"multiple",
        selected: legendSelected,
      },
      grid: {
        left:spaceLeft? spaceLeft:"3%",
        right:spaceRight? spaceRight: "4%",
        bottom:spaceBottom? spaceBottom: "3%",
        top:spacetop? spacetop: "0%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        max: xAxisMax,
        show:false,
        axisLabel: {
          formatter: '{value}',
          axisPointer:false,
        },
         ...otherXAxisProperty

      },
      yAxis: {
        type: "category",
        data: yAxisData,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: axisShowLabel ? aixsConfig===true?{
              formatter: yAxisFormatter ? yAxisFormatter : undefined,
              margin: yAxisMargin ? yAxisMargin : undefined,
              rich: yAxisRich ? yAxisRich : undefined,
              textStyle: {
                color: function (value) {
                  return yAxisTextColor[value];
                },
              },
            }:{         
              textStyle: {
                color: function (value) {
                return yAxisTextColor[value];
              },
            },
       }: null,
               ...otherYAxisProperty
      },
      series: data?.map((series ,index) => ({
        name: series.name,
        type: "bar",
        barWidth:barWidth ? barWidth : 11, 
        stack: 'stackName',
         label: labelConfig ? { ...labelConfig } : {
          show: false,
          position: "inside",
          formatter: '{c}',
        },
        itemStyle: {
          color: series.color , 
         },
         
        data: series.data.map((value, i) => {
          if (legendSelected[series.name] === false) {
            return 0;  
          }
          
          return isFullStack ? value.toFixed(2) :  ((value / categoryTotals[i]) * 100).toFixed(2);;
        }),
      ...series.otherSeriesProperty,
      }),
      ),
    };

    // Scroll (dataZoom) configuration
if (isScroll) {
  const isVertical = scrollDirection === "vertical";
const fixedStart = isScrollStartLimit ?? 80; // closer to top
const fixedEnd = isScrollEndLimit ?? 100;    // topmost


  option.dataZoom = [
    {
      type: "slider",
      orient: isVertical ? "vertical" : "horizontal",
      [isVertical ? "yAxisIndex" : "xAxisIndex"]: 0,
      start: fixedStart,
      end: fixedEnd,
      height: isVertical ? "auto" : 15,
      width: isVertical ? 15 : "auto",
      bottom: isVertical ? "auto" : scrollBarBottomAlign ?? 15,
      right: isVertical ? scrollBarBottomAlign ?? 15 : "auto",
      show: true,  
      zoomLock: true,            
      moveOnMouseWheel: false,     
      moveOnMouseMove: false,     
      handleSize: 0,              
      showDetail: false, 
      handleStyle: {
        color: color?.[0],
      },
      dataBackground: {
        lineStyle: {
          color: color?.[0],
        },
        areaStyle: {
          color: "rgba(255, 0, 0, 0.1)",
        },
      },
    },
    {
      type: "inside",
      orient: isVertical ? "vertical" : "horizontal",
      [isVertical ? "yAxisIndex" : "xAxisIndex"]: 0,
      start: fixedStart,
      end: fixedEnd,
      zoomLock: true,
      moveOnMouseWheel: false,
      moveOnMouseMove: false,
    },
  ];
}



    return option;
  };

      const handleChartClick = (params) => {
        props.handleChartClick(params);
      };
      const handleLegendSelectChanged = (params) => {
        setLegendSelected(params.selected);
      };

      const onEvents = {
        'click': handleChartClick,
        'legendselectchanged': handleLegendSelectChanged,
      };

      useEffect(() => {
        if (props.events && props.events.selected) {
          setLegendSelected(props.events.selected);
        }
      }, [props.events]);

  return <ReactECharts option={getStackOption()} style={{ width:width?width: '100%', height:height?height: '400px' }} onEvents={events ? onEvents : ""} />;
  
};


function areEqual(prevProps, nextProps) {
  if(_.isEqual(prevProps.data, nextProps.data) &&
  _.isEqual(prevProps.yAxisData, nextProps.yAxisData) &&
  _.isEqual(prevProps.color, nextProps.color) &&
  _.isEqual(prevProps.yAxisTextColor, nextProps.yAxisTextColor) &&
  _.isEqual(prevProps.width, nextProps.width) &&
  _.isEqual(prevProps.height, nextProps.height) &&
  _.isEqual(prevProps.height, nextProps.height) &&
  _.isEqual(prevProps.spaceLeft, nextProps.spaceLeft) &&
  _.isEqual(prevProps.spaceRight, nextProps.spaceRight) &&
  _.isEqual(prevProps.spaceBottom, nextProps.spaceBottom) &&
  _.isEqual(prevProps.spacetop, nextProps.spacetop) &&
  _.isEqual(prevProps.yAxisMargin, nextProps.yAxisMargin) &&
  _.isEqual(prevProps.showLegend, nextProps.showLegend)&&
  _.isEqual(prevProps.xAxisMax, nextProps.xAxisMax)&&
  _.isEqual(prevProps.labelConfig, nextProps.labelConfig)&&
  _.isEqual(prevProps.otherYAxisProperty, nextProps.otherYAxisProperty)&&
  _.isEqual(prevProps.otherXAxisProperty, nextProps.otherXAxisProperty)&&
  _.isEqual(prevProps.axisShowLabel, nextProps.axisShowLabel)&&
  _.isEqual(prevProps.selectedMode, nextProps.selectedMode)
) {
    return true;
  } else {
    return false;
  }
}
StackedBarChart.propTypes = {
  aixsConfig: PropTypes.bool,
  barWidth: PropTypes.number,
  color: PropTypes.array,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.number),
    color: PropTypes.string,
    toolTipData: PropTypes.arrayOf(PropTypes.shape({
      severity: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }))
  })).isRequired,
  events: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  spaceLeft: PropTypes.string,
  spaceBottom: PropTypes.string,
  spacetop: PropTypes.string,
  spaceRight: PropTypes.string,
  toolTipData: PropTypes.any, // Optional: Based on your tooltip formatter logic
  tooltipConfig: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  yAxisData: PropTypes.arrayOf(PropTypes.string).isRequired,
  yAxisDataArray: PropTypes.array, // You can refine this based on usage
  yAxisFormatter: PropTypes.func,
  yAxisMargin: PropTypes.number,
  yAxisRich: PropTypes.object,
  yAxisTextColor: PropTypes.object,
  handleChartClick: PropTypes.func.isRequired,
  xAxisMax:PropTypes.string,
  otherYAxisProperty: PropTypes.object,
  otherXAxisProperty: PropTypes.object,
  labelConfig: PropTypes.object,
  axisShowLabel:PropTypes.bool,
  isFullStack:PropTypes.bool,
  selectedMode:PropTypes.bool,
  isScroll:PropTypes.bool,
  scrollDirection:PropTypes.string,
  isScrollStartLimit:PropTypes.number,
  isScrollEndLimit:PropTypes.number,
  scrollBarBottomAlign:PropTypes.number,

};
export default React.memo(StackedBarChart, areEqual);



